import { useState } from 'react'
import { randomInt, uuid } from '@10000/common'
import { useBreakpoints, useRequest, useView } from '@10000/react'
import { InputScreen, onboardBackground, useBackground, useShell, useStack } from '../../layout'
import { Avatar, Text, Location } from '../../forms'
import { Box } from '../../widgets'
import { OrganisationIndustry } from './'

export const OrganisationCompany = ({ active, organisationId }) => {
  const request = useRequest('tenant')
  const { push } = useStack()
  const { organisations, company } = useView('tenant')
  const { mobile } = useBreakpoints()

  // use state as re-render causes the id of a new organisations to de-sync. This passes the incorrect ID to be passed to organisation industry
  const [organisation] = useState(
    organisationId
      ? organisations.find(x => x.id === organisationId)
      : { id: uuid(), avatar: randomInt(6), name: '', city: company?.city }
  )

  useShell({ active, mode: 'navigate narrow' })
  useBackground().set(mobile => ({ active, fade: false, ...onboardBackground(true, mobile) }))

  const handleOrganisationDetails = (details) => request(
    organisations.some(x => x.id === organisation.id) ? 'organisationUpdated' : 'organisationAdded',
    { id: organisation.id, ...details }
  ).then(() => push(OrganisationIndustry, { props: { organisationId: organisation.id } }))

  return (
    <InputScreen
      onSubmit={handleOrganisationDetails}
      fade
      formValues={organisation}
      footerButton="Next"
      title="Set up client&apos;s organisation"
      description="Create your initial organisation. You can always add more as you go!"
    >
      <Box justifyContent="center" alignItems="center" column gap={mobile ? 16 : 24}>
        <Avatar
          name="avatar"
          size={mobile ? 'medium' : 'large'}
          mode="company"
        />
        <Text name="name" title="Client organisation name" required/>
        <Location country={company?.country} />
      </Box>
    </InputScreen>
  )
}